// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import React, { ReactElement } from "react"
import { useTableContext } from "../../provider"
import { LifecycleState } from "../../types"
import { NoFilteredItems } from "./NoFilteredItems"
import { MuiIcon, styled } from "@cirrus/ui-kit"

const NoResultWrapper = styled("div")({
  textAlign: "center",

  "& svg": {
    width: 110,
    height: 110,
    color: "#0000008a",
    marginTop: 45
  }
})

const NoResultsBoldText = styled("div")({
  color: "#757575",
  padding: "16px",
  position: "relative",
  zIndex: 1,
  fontWeight: "bold"
})

const NoResultsText = styled("div")({
  color: "#757575",
  padding: "16px",
  position: "relative",
  zIndex: 1
})

export const NoRowsOverlay = (): ReactElement => {

  const ctx = useTableContext()

  if (ctx.props.isLoading || ctx.lifecycle.state < LifecycleState.Ready) {
    return <></>
  }

  if (
    Object.keys(ctx.filters.state.values).length === 0
    && !ctx.search.state.value
  ) {
    return (
      <NoResultWrapper>
        <MuiIcon.LensBlur />
        <NoResultsBoldText>{i18n(ctx.props.noResultsText || "General:MarkingStarted")}</NoResultsBoldText>
        <NoResultsText>{i18n(ctx.props.noResultsDesc ||"General:PerfomanceWillShowSoon")}</NoResultsText>
      </NoResultWrapper>
    )
  }

  return <NoFilteredItems />
}
